import { multiAutocompleteEnhancer } from '../gqlEnhancer';
import { MultiLocationAutocomplete } from './MultiLocationAutocomplete';

export default multiAutocompleteEnhancer(MultiLocationAutocomplete);

